<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>電波ログ取得</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-2">
        <div class="form-group">
          <input type="date" class="form-control" v-model="fromDate" :min=minDate :max=maxDate required>
        </div>
      </div>    
      <div class="col-2">
        <div class="form-group">
          <input type="date" class="form-control" v-model="toDate" :min=minDate :max=maxDate required>
        </div>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-6">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:50px">#</th>
              <th scope="col">ID</th>
              <th scope="col">名称</th>
              <th scope="col" style="width:80px">番号</th>
              <th scope="col" style="width:100px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" v-bind:key="user.id">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ user.userCode }}</td>
              <td>{{ user.userName }}</td>
              <td>{{ user.extensionNumber }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="request(user.id)">実行</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      users: [],
      message: '',
      fromDate: this.$moment().add(-7, "days").format('YYYY-MM-DD'),
      toDate: this.$moment().format('YYYY-MM-DD'),
      minDate: this.$moment().add(-7, "days").format('YYYY-MM-DD'),
      maxDate: this.$moment().format('YYYY-MM-DD'),
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.search()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search()
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/log/device/index'))
    },
    request(userId) {
      if (this.$moment(this.fromDate).isAfter(this.toDate)) {
        this.message = "取得開始日を取得終了日以前に設定してください。"
        return
      }
      if (this.$moment(this.fromDate).isBefore(this.minDate)) {
        this.message = "取得開始日が指定可能範囲外です。"
        return
      }
      if (this.$moment(this.toDate).isAfter(this.maxDate)) {
        this.message = "取得終了日が指定可能範囲外です。"
        return
      }
      this.message = ""
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios
            .post("/api/monitoring/log/request", {
              userId: userId,
              hospitalId: hospitalId,
              from: this.fromDate,
              to: this.toDate
            },{
              headers: this.headers(accessToken)
            })
            .then(response => {
              var res = response.data;
              if(res.errorMessage) {
                this.message = res.errorMessage
              } else {
                alert('取得要求を送信しました。')
              }
            })
            .catch(err => {
              this.message = err.message
            })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    search() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios
            .get("/api/user/online/list/" + hospitalId , {
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.users = response.data.data.users
            })
            .catch(err => {
              this.message = err.message
            })
        }
      }).catch((err) => {
        this.message = err.message
      })
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
button {
  margin-right: 10px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>